<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="cd"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Código</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="descr"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Descrição</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2">
            <multiselect
              v-model="paramTipoArea"
              :options="optionsParamTipoArea"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Parametro Tipo"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2">
            <multiselect
              v-model="unidade"
              :options="optionsUnidade"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Unidade"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2">
            <multiselect
              v-model="pallet"
              :options="optionsPallet"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Pallet"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2">
            <multiselect
              v-model="regiao"
              :options="optionsRegiao"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Região"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2">
            <multiselect
              v-model="status"
              :options="optionsLivStatus"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2" class="p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="qrcode"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Qr Code</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      helpForm: new Form({ params: [] }),
      cd : "", // clear the text in text input
      descr : "",
      partparea_id : "",
      pallet : [],
      regiao: [],
      unidade: [],
      qrcode : "",
      optionsLivStatus: [],
      optionsParamTipoArea: [],
      status: [],
      paramTipoArea: [],
      optionsUnidade: [],
      optionsPallet: [],
      optionsRegiao: [],
      data_filter: [],
    };
  },
  watch: {
    statusLivSelected(obj) {
      this.status = obj.value;
    },
  },
  mounted() {
    this.getStatus();
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.data_filter = {
        cd: this.cd,
        descr: this.descr,
        status: this.status,
        paramTipoArea: this.paramTipoArea ? this.paramTipoArea.value : null,
        unidade: this.unidade ? this.unidade.value : null,
        pallet: this.pallet ? this.pallet.value : null,
        regiao: this.regiao ? this.regiao.value : null,
        qrcode: this.qrcode
      };
      this.$events.fire("filter-set", this.data_filter);
    },
    resetFilter() {
      this.cd = ""; // clear the text in text input
      this.descr = "";
      this.status = "";
      this.partparea_id = "";
      this.pallet = null;
      this.regiao = null;
      this.paramTipoArea = null;
      this.qrcode = "";
      this.unidade = null;
      this.$events.fire("filter-reset");
    },
    getStatus() {
      this.helpForm.params = { tabela: "pais", coluna: "status" };

      this.helpForm
        .get("/api/area/jsonlistfilters")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.paramTipoArea.forEach((obj) => {
            this.optionsParamTipoArea.push({
              label: obj.descr,
              value: obj.partpareaId,
            });
          });
          response.unidade.forEach((obj) => {
            this.optionsUnidade.push({
              label: obj.descr,
              value: obj.unidade_id,
            });
          });
          response.status.forEach((obj) => {
            this.optionsLivStatus.push({
              label: obj.descr,
              value: obj.valor
            });
          });
          response.pallet.forEach((obj) => {
            this.optionsPallet.push({
              label: obj.cd,
              value: obj.pallet_id
            });
          });
          response.regiao.forEach((obj) => {
            this.optionsRegiao.push({
              label: obj.descr,
              value: obj.regiaoId
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, false, false);
        });
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>
